import getFetchResponse, { ApiResponse } from '../get-fetch-response'

type UserInitializePayload = ApiResponse & {
  // also includes categories and surverSent properties, but that's not relevant to WSU
  user: {
    id: string
    cognitoId: string
    cohortId: string
    companyId: string
    onboardingAssessmentResults: string
    timeZone: string
    createdAt: string // date-time
    updatedAt: string // date-time
  }
}

// https://petstore.swagger.io/?url=https://staging-api.thriveglobal.com/v1/swagger.json#/users/post_users_initialize
export const userInitialize = async (email: string) => {
  const body = { userName: email }
  const res = await getFetchResponse<UserInitializePayload>({
    method: 'POST',
    path: '/v1/users/initialize',
    body,
  })

  return res
}
